import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';

const BradCrumb = ({
                     homeElement,
                     separator,
                     containerClasses,
                     listClasses,
                     activeClasses,
                     capitalizeLinks,
                   }) => {
  const router = useRouter();
  const paths = router.pathname;
  const pathNames = paths.split('/').filter(path => path);
  pathNames.pop();
  return (
      <ul className={containerClasses}>
        <li className={listClasses}>
          <Link href={'/'}>{homeElement}</Link>
        </li>
        <li className={'px-5'}> {pathNames.length > 0 && separator}</li>
        {pathNames.map((link, index) => {
          let href = `/${pathNames.slice(0, index + 1).join('/')}`;
          let itemClasses =
            paths === href ? `${listClasses} ${activeClasses}` : listClasses;
          let itemLink = capitalizeLinks
            ? link[0].toUpperCase() + link.slice(1, link.length)
            : link;
          return (
               <li key={"crumb" + capitalizeLinks} className={itemClasses}>
                <Link href={href}>{itemLink}</Link>
              </li>
           );
        })}
      </ul>
  );
};

export default BradCrumb;
